
export default {
    customers: '',
    cliente: '/cliente',
   
  };
  